import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WorkEvent } from '../../_generated/work-rest-api';

@Component({
  selector: 'ax-event-item',
  templateUrl: './ax-event-item.component.html',
  styleUrls: ['./ax-event-item.component.scss'],
})
export class AxEventItemComponent implements OnInit {
  @Input() eventItem: WorkEvent;
  @Output() open: EventEmitter<WorkEvent> = new EventEmitter<WorkEvent>();

  constructor() {
  }

  ngOnInit() {
  }
}
